import SignatureOptionState from './schema/SignatureOptionState';
import createRibbonViewState from 'owa-editor-ribbonplugin/lib/utils/createRibbonViewState';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
import { createStore } from 'satcheljs';

export default createStore<SignatureOptionState>('signatureOption', {
    editorViewState: createEditorViewState(null /*content*/, false /*isDirty*/),
    ribbon: createRibbonViewState(),
    signNewMails: null,
    signReplies: null,
})();
